var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg100MlE(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 31,
    viewBox: "0 0 37 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0095DF",
    d: "M35 9H1l1 15 2 2 4 3h21l4-3 2-5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#47464A",
    d: "M31.86 28.442a11.627 11.627 0 0 0 4.262-7.756l.077-18.1A2.589 2.589 0 0 0 33.613 0H2.585A2.588 2.588 0 0 0 0 2.586v16.806c0 3.654 1.696 6.916 4.338 9.05l1.326.706a15 15 0 0 0 7.048 1.759H24.809c2.561 0 5.047-.87 7.05-2.465zm-29.275-9.05v-9.05h16.807a1.293 1.293 0 0 0 0-2.584H2.585V2.586h31.028v5.172H27.15a1.292 1.292 0 1 0 0 2.584h6.464v9.05c0 4.99-4.06 9.05-9.05 9.05H11.635c-4.99 0-9.05-4.06-9.05-9.05z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg100MlE);
export default __webpack_public_path__ + "static/media/100_ml_e.0e6cda2550096f78816b9e9554aa6363.svg";
export { ForwardRef as ReactComponent };